import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHollowCircle = forwardRef((props, ref) => {
	return React.createElement(SvgIcon, {
		...props,
		ref
	}, /* @__PURE__ */ _jsx("circle", {
		cx: 12,
		cy: 12,
		r: 11,
		stroke: "currentColor",
		strokeWidth: 1.5,
		fill: "none"
	}));
});
export default SvgHollowCircle;
